export const MAX_CONTENT_SIZE = 3000;

export const DEFAULT_MAX_SPEND_PER_CONTRIBUTION = 10;

export const DEFAULT_VOTES_PER_PLAY = 10;

export const DEFAULT_PRESELECTED_VOTE_VALUE = 1;
